import {
    GET_BULK_ORDER_SAVE,
    SET_BULK_ORDER_SAVE
} from "./BulkOrderSaveType"

const getSaveBulkOrder = (bulkorderSave: any) => ({
    type: GET_BULK_ORDER_SAVE,
    bulkorderSave
})

const setSaveBulkOrder = (bulkOrderSaveValue: any) => ({
    type: SET_BULK_ORDER_SAVE,
    bulkOrderSaveValue: bulkOrderSaveValue
})

export {
    getSaveBulkOrder,
    setSaveBulkOrder
}